import T from 'prop-types';

export default T.shape({
  questions: T.arrayOf(
    T.shape({
      id: T.number.isRequired,
      title: T.string.isRequired,
      question_answers: T.arrayOf(T.string).isRequired
    })
  )
});



// WEBPACK FOOTER //
// ./src/shapes/fixedInput.js